
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/gemini",
      function () {
        return require("private-next-pages/android/local/gemini/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/gemini"])
      });
    }
  